import { z } from 'zod';

import { PaginationSchema } from '../../pagination.js';

export const PricePromotionTargetKindSchema = z.enum(['SKU', 'BRAND', 'CATEGORY']);

export const ListPlacePricePromotionsQuerySchema = PaginationSchema.extend({
  q: z.string().trim().min(1).max(100).optional(),
});

export const PlacePricePromotionSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  targetKind: PricePromotionTargetKindSchema,
  targetId: z.uuid(),
  targetName: z.string().nullable(),
  discountBp: z.number().int().min(0).max(10_000),
  validFrom: z.iso.datetime(),
  validUntil: z.iso.datetime(),
});

export const ListPlacePricePromotionsResponseSchema = z.object({
  items: z.array(PlacePricePromotionSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int().positive(),
  }),
});

export const SavePlacePricePromotionBodySchema = z.object({
  name: z.string().trim().min(1).max(120),
  targetKind: PricePromotionTargetKindSchema,
  targetId: z.uuid(),
  discountBp: z.number().int().min(0).max(10_000),
  validFrom: z.iso.datetime(),
  validUntil: z.iso.datetime(),
});

export const UpdatePlacePricePromotionBodySchema = z.object({
  discountBp: z.number().int().min(0).max(10_000),
});

export const EndPlacePricePromotionResponseSchema = z.object({
  id: z.uuid(),
});

export type ListPlacePricePromotionsQuery = z.infer<typeof ListPlacePricePromotionsQuerySchema>;
export type PlacePricePromotion = z.infer<typeof PlacePricePromotionSchema>;
export type ListPlacePricePromotionsResponse = z.infer<
  typeof ListPlacePricePromotionsResponseSchema
>;
export type SavePlacePricePromotionBody = z.infer<typeof SavePlacePricePromotionBodySchema>;
export type UpdatePlacePricePromotionBody = z.infer<typeof UpdatePlacePricePromotionBodySchema>;
export type EndPlacePricePromotionResponse = z.infer<typeof EndPlacePricePromotionResponseSchema>;
